import {type RouteRecordRaw} from 'vue-router';

const ChatIndex = () => import('../views/chat/ChatIndex.vue');

let meta: MetaData = {
    module: 'chat',
    layout: 'blank',
};

let chat: RouteRecordRaw[] = [
    {
        path: '/chat',
        name: 'chat-index',
        component: ChatIndex,
        meta,
    },
];

export default chat;
